<div class="expanding-details-container">
  <div fxLayout="{{flexDirection}}">
    <button mat-button [title]="label" class="_pendo-view-more" (click)="onExpansionClick()" fxFill>
      <div fxFlex fxLayoutAlign="start">
        <zui-icon [icon]="icon" class="activity-icon"></zui-icon>
        <div class="activity-details" >
          <p class="activity-value">{{ label | truncate: 25 }}</p>
          <div *ngIf="showDriverStatus" class="driver-status" [ngClass]="_driverActivityStatus">
            <span class="glyphs driver-status-indicator" [ngClass]="_driverActivityStatus">{{ _activityGlyph}}</span>
            <span class="driver-status-text">{{ translateService.get(translations.driverStatus[_driverActivityStatus] || translations.driverStatus.unknown) | async | translate }}</span>
          </div>
        </div>
      </div>
      <mat-icon *ngIf="isAnyDisplayableField" class="expand-icon" fxFlex="10"
        fxLayoutAlign="end center">{{expansionIcon}}</mat-icon>
    </button>
  </div>
  <div *ngIf="isExpanded" class="expansion-content" [class.bottom-border]="bottomBorderOnExpanded"
    fxLayout="{{flexDirection}}" fxFill>
    <ng-content></ng-content>
  </div>
</div>